import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../hoc/StyledTitle';
import ToolTip from './AssetPropertyView';

import './Button.css';

@StyledTitle
class Button extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    iconCls: PropTypes.string,
    imgCls: PropTypes.string,
    type: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    disabled: PropTypes.bool,
    draggable: PropTypes.bool,
    onClick: PropTypes.func,
    style: PropTypes.object,
    tooltipStyle: PropTypes.object,
    children: PropTypes.any,
    labelClass: PropTypes.string,
    tabIndex: PropTypes.number,
    btnType: PropTypes.string
  };

  static defaultProps = {
    type: 'plain',
    className: '',
    title: '',
    style: {},
    tooltipStyle: {},
    labelClass: '',
    btnType: ''
  };

  renderButton() {
    const {
      icon,
      iconCls,
      imgCls,
      type,
      text,
      className,
      title,
      disabled,
      onClick,
      style,
      children,
      labelClass,
      tooltipStyle,
      btnType,
      id
    } = this.props;
    const label = text || children;
    const draggable = this.props.draggable !== undefined ? this.props.draggable : true;
    return (
      <button
        className={`${className} ${type.toLowerCase()}`}
        // title={title}
        id={id}
        type={btnType}
        name="Button"
        onClick={onClick}
        disabled={disabled}
        style={style}
        tabIndex={this.props.tabIndex}>
        {icon ? <img src={icon} className={imgCls} draggable={draggable} /> : null}
        {iconCls ? <span className={iconCls} /> : null}
        {label ? <span className={labelClass}>{label}</span> : null}
      </button>
    );
  }

  render() {
    return this.props.title ? (
      <ToolTip text={this.props.title} style={this.props.tooltipStyle}>
        {this.renderButton()}
      </ToolTip>
    ) : (
      this.renderButton()
    );
  }
}

export default Button;
